(function () {
  var i18n = (window.customwearOmnibus && window.customwearOmnibus.i18n) || {};

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function savingLabel(percent) {
    var tpl = i18n.saving || 'Oszczędzasz %d%%';
    return tpl.replace('%d', String(percent));
  }

  function setRegularRow(row, amountEl, html, show) {
    if (!row) {
      return;
    }
    row.classList.toggle('cw-product-price-block__regular--hidden', !show);
    if (amountEl) {
      amountEl.innerHTML = html || '';
    }
  }

  function setOmnibusRow(row, wasEl, omnibus) {
    if (!row) {
      return;
    }
    if (!omnibus || !omnibus.show_omnibus) {
      row.classList.add('cw-product-price-block__omnibus--hidden');
      if (wasEl) {
        wasEl.innerHTML = '';
      }
      return;
    }
    row.classList.remove('cw-product-price-block__omnibus--hidden');
    if (wasEl) {
      wasEl.innerHTML = omnibus.lowest_html || '';
    }
  }

  function setSavingBadge(badge, percent, show) {
    if (!badge) {
      return;
    }
    badge.classList.toggle('cw-product-price-block__saving--hidden', !show);
    badge.textContent = show && percent > 0 ? savingLabel(percent) : '';
  }

  function updateFromVariation(variation) {
    var block = qs('[data-cw-product-price-block]');
    if (!block || !variation) {
      return;
    }

    var amount = qs('[data-cw-price-amount]', block) || qs('.cw-product-price-block__amount', block);
    var regularRow = qs('[data-cw-price-regular]', block);
    var regularAmount = qs('[data-cw-price-regular-amount]', block);
    var omnibusRow = qs('[data-cw-omnibus-row]', block);
    var omnibusWas = qs('[data-cw-omnibus-was]', block);
    var savingBadge = qs('[data-cw-price-saving]', block);
    var omnibus = variation.cw_omnibus || null;

    if (amount) {
      if (omnibus && omnibus.current_html) {
        amount.innerHTML = omnibus.current_html;
      } else if (variation.price_html) {
        amount.innerHTML = variation.price_html;
      }
    }

    var onSale =
      (omnibus && omnibus.show_regular) ||
      (variation.display_regular_price != null &&
        variation.display_price != null &&
        Number(variation.display_regular_price) > Number(variation.display_price));

    if (onSale) {
      block.classList.add('cw-product-price-block--sale');
    } else {
      block.classList.remove('cw-product-price-block--sale');
    }

    setRegularRow(
      regularRow,
      regularAmount,
      omnibus && omnibus.regular_html ? omnibus.regular_html : '',
      !!(omnibus && omnibus.show_regular)
    );
    setOmnibusRow(omnibusRow, omnibusWas, omnibus);
    setSavingBadge(
      savingBadge,
      omnibus && omnibus.saving_percent > 0 ? omnibus.saving_percent : 0,
      !!(omnibus && omnibus.show_saving)
    );
  }

  function init() {
    var block = qs('[data-cw-product-price-block].cw-product-price-block--variable');
    if (!block) {
      return;
    }
    var form = qs('form.variations_form');
    if (!form || typeof jQuery === 'undefined') {
      return;
    }
    jQuery(form).on('found_variation', function (_ev, variation) {
      updateFromVariation(variation);
    });
    jQuery(form).on('reset_data hide_variation', function () {
      var regularRow = qs('[data-cw-price-regular]', block);
      var regularAmount = qs('[data-cw-price-regular-amount]', block);
      var omnibusRow = qs('[data-cw-omnibus-row]', block);
      var omnibusWas = qs('[data-cw-omnibus-was]', block);
      var savingBadge = qs('[data-cw-price-saving]', block);
      block.classList.remove('cw-product-price-block--sale');
      setRegularRow(regularRow, regularAmount, '', false);
      setOmnibusRow(omnibusRow, omnibusWas, null);
      setSavingBadge(savingBadge, 0, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
